import { IntlShape } from "react-intl";
import { StepOptions, Tour } from "shepherd.js";

export type TourStepId = "launch-sky" | "doc-list" | "ai-sidebar";

interface CreateTourStepsOptions {
  intl: IntlShape;
  onSkip: (stepId: TourStepId) => void;
  onComplete: () => void;
}

const createSkipButton = (
  intl: IntlShape,
  onSkip: (stepId: TourStepId) => void,
  stepId: TourStepId
) => ({
  text: intl.formatMessage({ id: "onboarding.button.skip" }),
  action: function (this: Tour) {
    onSkip(stepId);
  },
  classes: "shepherd-button-secondary",
});

const createNextButton = (intl: IntlShape) => ({
  text: intl.formatMessage({ id: "onboarding.button.next" }),
  action: function (this: Tour) {
    this.next();
  },
  classes: "shepherd-button-primary",
});

const createDoneButton = (intl: IntlShape, onComplete: () => void) => ({
  text: intl.formatMessage({ id: "onboarding.button.done" }),
  action: onComplete,
  classes: "shepherd-button-primary",
});

export const createCasePageSteps = ({
  intl,
  onSkip,
}: CreateTourStepsOptions): StepOptions[] => [
  {
    id: "launch-sky",
    title: intl.formatMessage({ id: "onboarding.launchSky.title" }),
    text: intl.formatMessage({ id: "onboarding.launchSky.text" }),
    attachTo: {
      element: '[data-tour="launch-sky"]',
      on: "left",
    },
    advanceOn: {
      selector: '[data-tour="launch-sky"]',
      event: "click",
    },
    buttons: [createSkipButton(intl, onSkip, "launch-sky")],
    scrollTo: true,
    canClickTarget: true,
  },
];

export const createSkyViewSteps = ({
  intl,
  onSkip,
  onComplete,
}: CreateTourStepsOptions): StepOptions[] => [
  {
    id: "doc-list",
    title: intl.formatMessage({ id: "onboarding.docList.title" }),
    text: intl.formatMessage({ id: "onboarding.docList.text" }),
    attachTo: {
      element: '[data-tour="doc-list"]',
      on: "right",
    },
    buttons: [
      createSkipButton(intl, onSkip, "doc-list"),
      createNextButton(intl),
    ],
    scrollTo: true,
  },
  {
    id: "ai-sidebar",
    title: intl.formatMessage({ id: "onboarding.aiSidebar.title" }),
    text: intl.formatMessage({ id: "onboarding.aiSidebar.text" }),
    attachTo: {
      element: '[data-tour="ai-sidebar"]',
      on: "left",
    },
    buttons: [createDoneButton(intl, onComplete)],
    scrollTo: true,
  },
];
